// Enhanced color palette matching the first dashboard
export const COLORS = [
    "#4F46E5", // Indigo
    "#10B981", // Emerald
    "#F59E0B", // Amber
    "#EF4444", // Red
    "#8B5CF6", // Violet
    "#06B6D4", // Cyan
    "#84CC16", // Lime
    "#F97316", // Orange
    "#EC4899", // Pink
  ];
  
  export const EMPLOYEE_CATEGORIES = {
    BOARD_OF_DIRECTORS: 'Board of Directors',
    KEY_MANAGERIAL_PERSONNEL: 'Key Managerial Personnel',
    EMPLOYEES_OTHER: 'Employees other than BoD and KMPs',
    WORKERS: 'Workers'
  };
  
  export const TRAINING_CATEGORIES = {
    HEALTH_SAFETY: 'Health & Safety',
    SKILL_DEVELOPMENT: 'Skill Development',
    HUMAN_RIGHTS: 'Human Rights'
  };
  
  export const CHART_DIMENSIONS = {
    DEFAULT_HEIGHT: 400,
    DEFAULT_WIDTH: 800,
    MARGIN: { top: 40, right: 80, bottom: 120, left: 80 }
  };